export default {"src":"/_next/static/media/Right-arrow.074fdc2f.svg","height":13,"width":8,"blurWidth":0,"blurHeight":0};